// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentMemberNumberDetails {
    static getAttributeTypeMap() {
        return BasicEnrollmentMemberNumberDetails.attributeTypeMap;
    }
}
BasicEnrollmentMemberNumberDetails.discriminator = undefined;
BasicEnrollmentMemberNumberDetails.additionalProperties = false;
BasicEnrollmentMemberNumberDetails.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
];
//# sourceMappingURL=basicEnrollmentMemberNumberDetails.js.map